module.exports = __webpack_public_path__ + "static/media/night-mode.bb132e84.svg";